import React from "react";
import styled from "styled-components";
import { ellipsis } from "polished";
import { letterSpacing } from "styled-system";
import { Box, Select as RebassSelect, Text as RebassText } from "rebass";
import { ChevronDownIcon } from "components";
import { ChevronDown } from "react-feather";

const Wrapper = styled(Box)`
  position: relative;
  user-select: none;
`;

const Container = styled(Box)`
  position: relative;
  height: 24px;

  svg {
    stroke: ${(props) => props.theme.colors.grey[0]};
    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);
    will-change: stroke;
  }

  &:hover {
    select {
      color: ${(props) => props.theme.colors.violet};
      box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.violet};
    }
    svg {
      stroke: ${(props) => props.theme.colors.violet};
    }
  }
  &:active {
  }
`;

const Title = styled(RebassText)`
  display: block;
  margin-bottom: 4px;
  color: ${(props) => props.theme.colors.grey[0]};
  ${letterSpacing};
  text-transform: uppercase;
`;

Title.defaultProps = {
  is: "label",
  m: 0,
  color: "text",
  fontSize: 0,
  fontWeight: "bold",
  lineHeight: 3,
  letterSpacing: "caps",
};

const SelectContainer = styled.select`
  position: relative;
  width: 100%;
  margin: 0;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  color: ${(props) => props.theme.colors.grey[0]};
  font-family: ${(props) => props.theme.fonts.sans};
  font-size: 16px;
  font-weight: 600;
  line-height: ${(props) => props.theme.lineHeights[3]};
  border: 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.grey[0]};
  cursor: pointer;
  appearance: none;
  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1),
    outline 500ms cubic-bezier(0.23, 1, 0.32, 1),
    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);
  will-change: color, box-shadow;
  ${ellipsis()};
  outline-color: ${(props) => props.theme.colors.grey[1]};

  &:not(:lang(ar)) {
    padding-right: 20px;
  }
  &:lang(ar) {
    padding-left: 20px;
  }

  &:focus {
    background-color: ${(props) => props.theme.colors.grey[1]};
    outline-style: solid;
    outline-width: 8px;
    outline-offset: 0px;
  }
`;

const Icon = styled(Box)`
  position: absolute;
  top: 50%;
  width: 20px;
  height: 24px;
  pointer-events: none;
  transform: translateY(-50%);

  &:not(:lang(ar)) {
    right: 0;
  }
  &:lang(ar) {
    left: 0;
  }

  > * {
  }
`;

class Select extends React.Component {
  render() {
    let options = this.props.options.map((option, index) => (
      <option key={option.label + index} value={option.value}>
        {option.label}
      </option>
    ));
    return (
      <Wrapper {...this.props}>
        {this.props.header && <Title children={this.props.header} />}
        <Container>
          <SelectContainer
            id={this.props.id}
            name={this.props.name}
            value={this.props.value}
            onChange={this.props.onChange}
            {...this.props}
          >
            {options}
            {this.props.children}
          </SelectContainer>
          <Icon>
            <ChevronDown size={24} strokeWidth={1.5} />
          </Icon>
        </Container>
      </Wrapper>
    );
  }
}

Select.defaultProps = {
  options: [],
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.js